import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import _every from 'lodash/every';
import _map from 'lodash/map';
import { getPalette } from '../utils/palette';
import ChartJs from 'chart.js';
import $ from 'jquery';
window.jQuery = $;
import { HubConnectionBuilder } from '@microsoft/signalr';

class DisplayGraphBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            isPortalMode: false,
            showPortalMode: false,
            fetchedData: {},
            chartElementId: _uniqueId(
                `js-graph-display-chart-area-${this.props.blockId}-${this.props.formGuid}`
            ),
        };

        this.signalrProxyCallback = this.signalrProxyCallback.bind(this);
        this.chartReference = null;
        this.formStatusElement = null;

        this.formElement = document.querySelector('form');
        if (!!this.formElement) {
            this.formElement.querySelector("button[type='submit']").onclick =
                this.onFormSubmissionClick.bind(this);
        }
        this.formStatusElement = !!this.formElement
            ? this.formElement.querySelector('.Form__Status')
            : null;
    }

    componentWillMount() {
        this.setState({
            isPortalMode: !!this.formElement,
        });
    }

    validateForm(formElement) {
        let formElements = [];
        for (let i = 0; i < this.formElement.elements.length - 1; i++) {
            formElements.push(this.formElement.elements[i]);
        }

        return _every(
            formElements.map(
                (element) =>
                    element && element.validity && element.validity.valid
            )
        );
    }

    onFormSubmissionClick(event) {
        if (!this.formElement) {
            return;
        }

        if (this.validateForm(this.formElement)) {
            event.preventDefault();
            this.setState({ showPortalMode: true });
            this.fetchAndUpdateChart();
            setTimeout(this.fetchAndUpdateChart.bind(this), 3500);
        }
    }

    fetchAndUpdateChart() {
        const { blockId, languageBranch, formGuid } = this.props;

        fetch(
            `/api/forms/${formGuid}/data?displayGraphBlockContentId=${blockId}&language=${languageBranch}`
        )
            .then((response) => response.json())
            .then((fetchedData) => {
                this.setState({
                    fetchedData: fetchedData.optionsCount,
                });
                this.updateChart();
            });
        this.setState({
            loading: false,
        });
    }

    componentDidMount() {
        this.initChart();
        if (!this.state.isPortalMode) {
            this.fetchAndUpdateChart();
        } else {
            this.setState({
                loading: false,
            });
        }
        if (this.props.isRealtimeEnabled) {
            this.initSignalR();
        }
    }

    initSignalR() {
        let connection = new HubConnectionBuilder()
            .withUrl('/realtimeGraphUpdate')
            .build();
        connection.on('FormChanged', (arg1, arg2) =>
            this.signalrProxyCallback(arg1, arg2)
        );
        try {
            connection.start();
        } catch (error) {
            console.log('failed in connecting to the signalr server');
        }
    }

    signalrProxyCallback(eventName, formGuid) {
        if (eventName === 'form-updated' && this.props.formGuid === formGuid) {
            this.fetchAndUpdateChart();
        }
    }

    initChart() {
        const config = this.getChartConfig({});
        this.chartReference = new ChartJs(
            document.getElementById(this.state.chartElementId),
            config
        );
    }

    updateChart() {
        const newData = this.formatData(this.state.fetchedData);
        if (this.chartReference.data.labels.length !== newData.labels.length) {
            // more labels (i.e. answer alternatives) has been added, update everything
            this.chartReference.data = newData;
        } else {
            // only the number of answers has changed, update only data in order to prevent full redraw animation
            this.chartReference.data.datasets[0].data =
                newData.datasets[0].data;
        }
        this.chartReference.update();
    }

    deserialiseGraphType(graphType) {
        switch (graphType) {
            case 0:
                return 'doughnut';
            case 1:
                return 'bar';
            default:
                throw new Error(`Unsupported graphType value ${graphType}`);
        }
    }

    getChartConfig(options) {
        const data = this.formatData(options);
        const { graphType } = this.props;
        const type = this.deserialiseGraphType(graphType);
        return {
            type,
            data,
            options: {
                responsive: true,
                legend: {
                    position: 'bottom',
                },
                title: {
                    display: true,
                    text: 'Alle svar',
                },
                animation: {
                    animateScale: true,
                    animateRotate: true,
                },
                rotation: 1 * Math.PI,
                circumference: 1 * Math.PI,
                tooltips: {
                    callbacks: {
                        label: function (tooltipItems, data) {
                            var i,
                                label = [],
                                l = data.datasets.length;
                            for (i = 0; i < l; i += 1) {
                                label[i] =
                                    data.labels[tooltipItems.index] +
                                    ' : ' +
                                    data.datasets[i].data[tooltipItems.index] +
                                    ' %';
                            }
                            return label;
                        },
                    },
                },
            },
        };
    }

    formatData(options) {
        const round = this.round;
        var backgroundColor = getPalette(this.props.palette);

        if (!Object.keys(options) || Object.keys(options).length === 0) {
            return {
                labels: [],
                values: [
                    {
                        data: [],
                        backgroundColor,
                    },
                ],
            };
        }

        var optionsValueArray = Object.keys(options).map(function (key) {
            return options[key];
        });

        var total = optionsValueArray.reduce(function (acc, val) {
            return acc + val;
        }, 0);
        var optionsValueArrayPercentages = optionsValueArray.map(function (
            val
        ) {
            return round((val / total) * 100, 1);
        });

        var optionsKeyArray = Object.keys(options).map(function (key) {
            return key.toString();
        });

        return {
            labels: optionsKeyArray,
            datasets: [
                {
                    data: optionsValueArrayPercentages,
                    backgroundColor,
                },
            ],
        };
    }

    round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    renderGraph(isPortalMode, showPortalMode, chartElementId, loading) {
        const canvasParentClasses =
            !isPortalMode || (isPortalMode && showPortalMode) ? '' : 'hide';
        return (
            <>
                {loading && <p>Loading graph data . . .</p>}
                <div key={this.state.chartElementId}>
                    <div id="canvas-holder" className={canvasParentClasses}>
                        <canvas id={chartElementId}></canvas>
                    </div>
                </div>
            </>
        );
    }

    render() {
        const { isPortalMode, showPortalMode, chartElementId, loading } =
            this.state;
        return isPortalMode
            ? ReactDOM.createPortal(
                  this.renderGraph(
                      isPortalMode,
                      showPortalMode,
                      chartElementId,
                      loading
                  ),
                  this.formStatusElement
              )
            : this.renderGraph(
                  isPortalMode,
                  showPortalMode,
                  chartElementId,
                  loading
              );
    }
}

DisplayGraphBlock.defaultProps = {
    palette: 'annual',
};

DisplayGraphBlock.propTypes = {
    blockId: PropTypes.string.isRequired,
    languageBranch: PropTypes.string.isRequired,
    formGuid: PropTypes.string.isRequired,
    graphType: PropTypes.number.isRequired,
    palette: PropTypes.string.isRequired,
};

export default DisplayGraphBlock;
